import { Grid, Typography } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import HeaderPage from "../../components/HeaderPage/Index";
import { isMobile } from "react-device-detect";
import {
  clearData,
  getData,
  storeData,
  callChoice,
} from "../../utils/GlobalHelper";
import Loading from "../../components/loading/loading";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import DialogWait from "../../components/CustomDialog/DialogWait";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";
import Configs from "../../constants/Configs";
import GlobalApi from "../../utils/GlobalApi";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
import { formatterDate } from "../../utils/formatter";
import { isEmpty } from "lodash";
import { API_CODE_SUCCESS } from "../../constants/CommonConstant";

const useStyle = makeStyles({
  textContent: {
    fontFamily: "DB Heavent",
  },
  paddingTopBottom: {
    padding: "10px 0",
  },
});

const Suit = (props) => {
  const classes = useStyle();
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const [lang, setLang] = useState(getData("lang"));
  const [translations, setTranslations] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isModel, setIsModel] = useState(false);
  const [isModelWait, setIsModelWait] = useState(false);
  const [isCheck, setIsCheck] = useState(false);
  const [value, setValue] = useState("");
  const idc = getData("idc");
  const [jumpPage, setJumpPage] = useState(false);
  const checkuserinfo = getData("checkuserinfo");
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const idcAddr = getData("f2_idc_address");
  const curAddr = getData("f2_current_address");
  const workAddr = getData("f2_workplace_address");
  const docAddr = getData("f2_document_address");
  const career = getData("f3_career");
  let snapIdCard = getData("uploadImage");

  const checkJumpPage = async () => {
    await getImage();
    let productChoice = false;
    await callChoice(head_token).then((res) => {
      if (!isEmpty(res)) {
        res.forEach((e) => {
          e.items.forEach((item) => {
            if (item.selected === 1) productChoice = true;
          });
        });
      }
    });

    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(snapIdCard) ||
      isEmpty(idc) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(career) ||
      !productChoice
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const handleNext = () => {
    const chooce = getData("chooce");
    const suitJson = [];
    if (!getData("suit") && value !== checkLavel(chooce?.[4]?.[0]?.level)) {
      //TODO function

      let BreakException = {};
      const score_age = getAgeYear(formatterDate(idc?.birthday));
      try {
        if (value === 5) {
          chooce["1"].forEach((item, index) => {
            if (index === 0) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: score_age,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: score_age,
              });
            } else if (index <= 4 || index >= 6) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 1,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 1,
              });
              if (index === 9) throw BreakException;
            } else if (index === 5) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 2,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 2,
              });
            }
          });
        } else if (value === 4) {
          chooce["1"].forEach((item, index) => {
            if (index === 0) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: score_age,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: score_age,
              });
            } else if (index <= 5 || index >= 7) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 2,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 2,
              });
              if (index === 9) throw BreakException;
            } else if (index === 6) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 1,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 1,
              });
            }
          });
        } else if (value === 3) {
          chooce["1"].forEach((item, index) => {
            if (index === 0) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: score_age,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: score_age,
              });
            } else if (index === 1) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 3,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 3,
              });
            } else if (index === 2) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 4,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 4,
              });
            } else if (index === 3) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 3,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 3,
              });
            } else if (index === 4) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 3,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 3,
              });
            } else if (index === 5) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 3,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 3,
              });
            } else if (index === 6) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 2,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 2,
              });
            } else if (index === 7) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 3,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 3,
              });
            } else if (index === 8) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 2,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 2,
              });
            } else if (index === 9) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 2,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 2,
              });
              throw BreakException;
            }
          });
        } else if (value === 2) {
          chooce["1"].forEach((item, index) => {
            if (index === 0) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: score_age,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: score_age,
              });
            } else if (index === 1) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 3,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 3,
              });
            } else if (index === 2) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 4,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 4,
              });
            } else if (index === 3) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 3,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 3,
              });
            } else if (index === 4) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 4,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 4,
              });
            } else if (index === 5) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 4,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 4,
              });
            } else if (index === 6) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 3,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 3,
              });
            } else if (index === 7) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 4,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 4,
              });
            } else if (index === 8) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 4,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 4,
              });
            } else if (index === 9) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 3,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 3,
              });
              throw BreakException;
            }
          });
        } else if (value === 1) {
          chooce["1"].forEach((item, index) => {
            if (index === 0) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: score_age,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: score_age,
              });
            } else if (index <= 9) {
              suitJson.push({
                SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
                SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
                SAfsac_Score: 4,
                SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
                SAfsac_SubAnswer: item.SAfsac_SubAnswer
                  ? item.SAfsac_SubAnswer
                  : "",
                SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
                SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
                SAfsac_Delflag: 0,
                SAfsac_Answer: 4,
              });
            } else {
              throw BreakException;
            }
          });
        }
      } catch (error) {}
      storeData("suit_json", suitJson);
    } else {
      chooce["1"].forEach((item, index) => {
        suitJson.push({
          SAfsac_Id: item.SAfsac_Id ? item.SAfsac_Id : "null",
          SAfsac_SAmsa_Id: item.SAmsa_Id ? item.SAmsa_Id : "",
          SAfsac_Score: item.SAfsac_Score ? item.SAfsac_Score : "",
          SAfsac_SubId: item.SAfsac_SubId ? item.SAfsac_SubId : "",
          SAfsac_SubAnswer: item.SAfsac_SubAnswer ? item.SAfsac_SubAnswer : "",
          SAfsac_Remark: item.SAfsac_Remark ? item.SAfsac_Remark : "",
          SAfsac_Remark2: item.SAfsac_Remark2 ? item.SAfsac_Remark2 : "",
          SAfsac_Delflag: 0,
          SAfsac_Answer: item.SAfsac_Answer ? item.SAfsac_Answer : "",
        });
      });
      storeData("suit_json", suitJson);
    }
    props.history.push("/suit_10");
  };
  const getAgeYear = (birthday) => {
    let birthDate = new Date(birthday);
    let currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    let ageYear = currentYear - birthDate.getFullYear();

    if (ageYear > 60) {
      //61
      return 1;
    } else if (ageYear >= 45) {
      //45-60
      return 2;
    } else if (ageYear >= 35) {
      //35-44
      return 3;
    } else if (ageYear < 35) {
      // < 35
      return 4;
    }
    return currentYear - birthDate.getFullYear();
  };
  const handleChoice = (choice) => {
    setValue(choice);
    setIsCheck(!isEmpty(choice.toString()));
  };
  const checkLavel = (input) => {
    let level = "";
    switch (input) {
      case 5:
        level = 1;
        break;
      case 4:
        level = 2;
        break;
      case 3:
        level = 3;
        break;
      case 2:
        level = 4;
        break;
      case 1:
        level = 5;
        break;

      default:
        break;
    }
    return level;
  };
  const callGetSuit = async () => {
    setIsLoading(true);
    try {
      const header = {
        headers: {
          Accept: "application/json",
        },
      };
      await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/suitability/selbyhead`,
        { head_token: head_token },
        header,
      )
        .then((res) => {
          setIsLoading(false);
          storeData("chooce", res?.data?.Data);
          if (!isEmpty(res?.data?.Data?.[4]?.[0])) {
            const vl = res?.data?.Data?.[4]?.[0]?.level;
            handleChoice(checkLavel(vl));
          }
        })
        .catch((er) => {
          // console.log(er);
          setIsLoading(false);
          setIsModelWait(true);
        });
    } catch (error) {
      setIsLoading(false);
      setIsModelWait(true);
    }
  };
  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) setJumpPage(true);
    });
  }, []);
  useEffect(() => {
    callGetSuit();
    const translation = getData("Translations");
    if (!isEmpty(translation)) {
      setTranslations(translation);
    } else {
      props.history.push("/");
    }
  }, []);
  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.suit?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => (e ? props.history.push("/products_choice") : "")}
          />
          <Loading status={isLoading} />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.suit}
                        clickBack={(e) =>
                          props.history.push("/products_choice")
                        }
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          {" "}
                          <HeaderRight
                            title={translations?.[lang]?.suit?.title}
                          />
                          <ScrollBarComponent
                            content={
                              <Grid>
                                <Grid>
                                  <Typography className="text-primary font-weight-bold font-20">
                                    {translations?.[lang]?.suit?.content_title}
                                  </Typography>
                                </Grid>
                                <Grid
                                  className={clsx(
                                    classes.textContent,
                                    "font-18",
                                    classes.paddingTopBottom,
                                  )}
                                >
                                  {translations?.[lang]?.suit?.content_detail}
                                </Grid>

                                <Grid>
                                  <Typography className="text-primary font-weight-bold font-20">
                                    เลือกความเสี่ยงของคุณ
                                  </Typography>
                                </Grid>
                                <Grid>
                                  {/* suit 1 */}
                                  <Grid
                                    className={clsx(
                                      "suit suit-choice",
                                      value === 1 && "active",
                                    )}
                                    container
                                    onClick={() => {
                                      clearData("suit");
                                      handleChoice(1);
                                    }}
                                  >
                                    <Grid className="suit-choice-1" item />
                                    <Grid className="suit-choice-text " item>
                                      <Grid>
                                        {
                                          translations?.[lang]?.suit
                                            ?.suit_choice_1
                                        }
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  {/* suit 1 */}
                                  {/* suit 2 */}
                                  <Grid
                                    className={clsx(
                                      "suit suit-choice",
                                      value === 2 && "active",
                                    )}
                                    container
                                    onClick={() => {
                                      clearData("suit");
                                      handleChoice(2);
                                    }}
                                  >
                                    <Grid className="suit-choice-2" item />
                                    <Grid className="suit-choice-text " item>
                                      <Grid>
                                        {
                                          translations?.[lang]?.suit
                                            ?.suit_choice_2
                                        }
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  {/* suit 2 */}
                                  {/* suit 3 */}
                                  <Grid
                                    className={clsx(
                                      "suit suit-choice",
                                      value === 3 && "active",
                                    )}
                                    container
                                    onClick={() => {
                                      clearData("suit");
                                      handleChoice(3);
                                    }}
                                  >
                                    <Grid className="suit-choice-3" item />
                                    <Grid className="suit-choice-text " item>
                                      <Grid>
                                        {
                                          translations?.[lang]?.suit
                                            ?.suit_choice_3
                                        }
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  {/* suit 3 */}
                                  {/* suit 4 */}
                                  <Grid
                                    className={clsx(
                                      "suit suit-choice",
                                      value === 4 && "active",
                                    )}
                                    container
                                    onClick={() => {
                                      clearData("suit");
                                      handleChoice(4);
                                    }}
                                  >
                                    <Grid className="suit-choice-4" item />
                                    <Grid className="suit-choice-text " item>
                                      <Grid>
                                        {
                                          translations?.[lang]?.suit
                                            ?.suit_choice_4
                                        }
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  {/* suit 4 */}
                                  {/* suit 5 */}
                                  <Grid
                                    className={clsx(
                                      "suit suit-choice",
                                      value === 5 && "active",
                                    )}
                                    container
                                    onClick={() => {
                                      clearData("suit");
                                      handleChoice(5);
                                    }}
                                  >
                                    <Grid className="suit-choice-5" item />
                                    <Grid className="suit-choice-text " item>
                                      <Grid>
                                        {
                                          translations?.[lang]?.suit
                                            ?.suit_choice_5
                                        }
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  {/* suit 5 */}
                                </Grid>
                              </Grid>
                            }
                          />{" "}
                          <ButtonRight
                            isDisbled
                            disbled={isCheck}
                            text={translations?.[lang]?.suit?.next}
                            onNextPage={handleNext}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <DialogWait
            open={isModelWait}
            isModel={setIsModelWait}
            title={"ขออภัย"}
            massage={
              "เบอร์โทรศัพท์ที่ท่านระบุซ้ำกับข้อมูลในระบบ</br>กรุณากรอกข้อมูลอีกครั้ง</br>หรือติดต่อ DAOL Contact Center</br>0 2351 1800</br>"
            }
            btn={"ตกลง"}
          />
          <DialogCustoms
            open={isModel}
            isModel={setIsModel}
            title={"ท่านอยู่ระหว่างการเปิดบัญชี"}
            btnPrimary={"ดำเนินการต่อ"}
            btnSecondary={"กรอกข้อมูลใหม่"}
          />
        </>
      )}
    </>
  );
};
export default memo(Suit);
